@if (isLoading()) {
  <div class="global-loader-overlay">
    <div class="loader-content">
      <modus-wc-loader color="primary" size="lg" variant="spinner"></modus-wc-loader>
      <p class="loading-text">Loading...</p>
    </div>
  </div>
}
